Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lodash_1 = require("lodash");
var react_jss_1 = require("react-jss");
var SlideItem_1 = require("./SlideItem");
var styles_1 = require("./SlideItem/styles");
var animation_1 = require("./utils/animation");
var SlideItem = react_jss_1.default(styles_1.styles)(SlideItem_1.SlideItem);
var ContentSlider = /** @class */ (function (_super) {
    tslib_1.__extends(ContentSlider, _super);
    function ContentSlider(props) {
        var _this = _super.call(this, props) || this;
        _this.frameRef = React.createRef();
        _this.slidesPanelRef = React.createRef();
        _this.slidesRefs = [];
        _this.lastSlidesPanelLeftOffset = 0;
        _this.panelMoveAnimation = null;
        _this.updateSliderProportions = function () {
            if (!_this.frameRef.current) {
                return;
            }
            _this.frameRef.current.style.height = _this.frameHeight ? _this.frameHeight + "px" : 'auto';
            _this.slidesRefs.forEach(function (el) {
                if (!el) {
                    return;
                }
                el.style.width = _this.slideItemWidth + "px";
            });
            _this.forceUpdate();
        };
        _this.state = {
            activeSlideIdx: lodash_1.isInteger(_this.props.activeSlideIdx) ? _this.props.activeSlideIdx : 0
        };
        return _this;
    }
    ContentSlider.prototype.componentDidMount = function () {
        window.addEventListener('resize', this.updateSliderProportions);
        this.updateSliderProportions();
        this.scrollToSlideWithIdx(this.state.activeSlideIdx);
    };
    ContentSlider.prototype.componentDidUpdate = function (prevProps) {
        if (lodash_1.isInteger(this.props.activeSlideIdx) && (this.props.activeSlideIdx !== prevProps.activeSlideIdx)) {
            this.scrollToSlideWithIdx(this.props.activeSlideIdx);
        }
    };
    ContentSlider.prototype.componentWillUnmount = function () {
        this.panelMoveAnimation.stop();
        window.removeEventListener('resize', this.updateSliderProportions);
    };
    ContentSlider.prototype.render = function () {
        var _this = this;
        var classes = this.props.classes;
        return (React.createElement("div", { className: classes.container },
            this.props.shouldShowArrows && (React.createElement("div", { className: (this.state.activeSlideIdx <= 0) ? classes.leftArrowDisabled : classes.leftArrow, onClick: function () { return _this.scrollToSlideWithIdx(_this.state.activeSlideIdx - 1); } })),
            React.createElement("div", { ref: this.frameRef, className: classes.frame },
                React.createElement("div", { ref: this.slidesPanelRef, className: classes.slidesPanel }, lodash_1.range(0, this.props.slidesCount).map(function (idx) { return (React.createElement(SlideItem, { key: idx, isLastSlide: idx === (_this.props.slidesCount - 1), content: _this.props.slideSource({ idx: idx, activeIdx: _this.state.activeSlideIdx, width: Math.floor(_this.slideItemWidth) }), getRef: function (ref) { return _this.slidesRefs[idx] = ref; }, rightMargin: _this.getSlideMargin(idx), startMoveHandler: function () {
                        if (_this.panelMoveAnimation) {
                            _this.panelMoveAnimation.stop();
                        }
                        _this.lastSlidesPanelLeftOffset = _this.slidesPanelLeftOffset;
                    }, moveHandler: function (xDelta) { return _this.moveSlidesPanel(xDelta); }, endMoveHandler: function () {
                        if (typeof _this.props.endMoveHandler === 'function') {
                            _this.props.endMoveHandler(_this.slideIdToScrollTo);
                        }
                        _this.scrollToSlideWithIdx(_this.slideIdToScrollTo);
                    }, onClick: function () { return (idx !== _this.state.activeSlideIdx) && _this.scrollToSlideWithIdx(idx); } })); })),
                this.props.counterSource && (React.createElement("div", { className: classes.counterBlock }, this.props.counterSource(this.state.activeSlideIdx)))),
            this.props.shouldShowArrows && (React.createElement("div", { className: (this.state.activeSlideIdx >= (this.props.slidesCount - 1)) ? classes.rightArrowDisabled : classes.rightArrow, onClick: function () { return _this.scrollToSlideWithIdx(_this.state.activeSlideIdx + 1); } }))));
    };
    Object.defineProperty(ContentSlider.prototype, "rollbackSlideMargin", {
        get: function () {
            var defaultRollbackRatio = .15;
            if (!this.props.rollbackSlideRatio) {
                return this.frameWidth * defaultRollbackRatio;
            }
            return this.frameWidth * this.props.rollbackSlideRatio;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentSlider.prototype, "slidesPanelLeftOffset", {
        get: function () {
            return this.slidesPanelRef.current
                ? this.slidesPanelRef.current.offsetLeft
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentSlider.prototype, "slidesPanelWidth", {
        get: function () {
            return this.slidesPanelRef.current
                ? this.slidesPanelRef.current.offsetWidth
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentSlider.prototype, "frameWidth", {
        get: function () {
            return this.frameRef.current
                ? this.frameRef.current.offsetWidth
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentSlider.prototype, "frameHeight", {
        get: function () {
            return (this.props.sizeAspectRatio && this.frameRef.current)
                ? this.frameWidth * this.props.sizeAspectRatio
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentSlider.prototype, "slideItemWidth", {
        get: function () {
            return this.frameRef.current
                ? this.frameWidth * this.props.widthOffsetRatio
                : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ContentSlider.prototype, "slideIdToScrollTo", {
        get: function () {
            var slidesPanelAbsOffset = Math.abs(this.slidesPanelLeftOffset);
            var scrollDistance = slidesPanelAbsOffset + this.lastSlidesPanelLeftOffset;
            var shouldScrollNext = (scrollDistance - this.rollbackSlideMargin) > 0;
            var shouldScrollBack = (scrollDistance + this.rollbackSlideMargin) < 0;
            var slideIdToScroll = this.getSlideIdxByOffset(slidesPanelAbsOffset);
            if (shouldScrollBack) {
                var prevIdToScroll = slideIdToScroll - 1;
                return (prevIdToScroll > 0) ? prevIdToScroll : 0;
            }
            if (!shouldScrollNext) {
                slideIdToScroll = this.getSlideIdxByOffset(this.lastSlidesPanelLeftOffset);
            }
            return (slideIdToScroll > (this.slidesRefs.length - 1))
                ? (this.slidesRefs.length - 1)
                : slideIdToScroll;
        },
        enumerable: true,
        configurable: true
    });
    ContentSlider.prototype.getSlideMargin = function (slideIdx) {
        if (!this.props.slideMargin) {
            return 0;
        }
        var isLastSlide = slideIdx >= (this.props.slidesCount - 1);
        return !isLastSlide ? this.props.slideMargin : 0;
    };
    ContentSlider.prototype.scrollToSlideWithIdx = function (idx) {
        var _this = this;
        idx = Math.max(idx, 0);
        var lastIdx = this.slidesRefs.length - 1;
        var panelAbsOffset = Math.abs(this.slidesPanelLeftOffset);
        var offsetToScroll = 0;
        if (lastIdx <= idx) {
            offsetToScroll = panelAbsOffset - this.slidesRefs[lastIdx].offsetLeft + (this.frameWidth - this.slidesRefs[lastIdx].offsetWidth);
        }
        else {
            offsetToScroll = panelAbsOffset - this.slidesRefs[idx].offsetLeft;
        }
        this.panelMoveAnimation = animation_1.animate((function (progress) {
            var offset = -panelAbsOffset + offsetToScroll * progress;
            if (_this.slidesPanelRef.current) {
                _this.slidesPanelRef.current.style.left = offset + "px";
            }
            var activeSlideIdx = _this.getSlideIdxByOffset(offset);
            if (activeSlideIdx !== _this.state.activeSlideIdx) {
                _this.setState({ activeSlideIdx: activeSlideIdx });
            }
        }));
    };
    ContentSlider.prototype.getSlideIdxByOffset = function (offset) {
        var _this = this;
        var absOffset = Math.abs(offset);
        return lodash_1.findIndex(this.slidesRefs, function (ref) {
            return !!ref && (ref.offsetLeft >= absOffset) &&
                (ref.offsetLeft < (absOffset + _this.frameWidth));
        });
    };
    ContentSlider.prototype.moveSlidesPanel = function (xDelta) {
        if (!this.slidesPanelRef.current) {
            return;
        }
        var nextOffset = this.lastSlidesPanelLeftOffset + xDelta;
        if (nextOffset >= 0) {
            this.slidesPanelRef.current.style.left = '0px';
            if (this.state.activeSlideIdx !== 0) {
                this.setState({ activeSlideIdx: 0 });
            }
            return;
        }
        var endLimitOffset = this.slidesPanelWidth - this.frameWidth;
        if (Math.abs(nextOffset) > endLimitOffset) {
            nextOffset = -endLimitOffset;
        }
        this.slidesPanelRef.current.style.left = nextOffset + "px";
        var activeSlideIdx = this.getSlideIdxByOffset(this.slidesPanelLeftOffset);
        if (this.state.activeSlideIdx !== activeSlideIdx) {
            this.setState({ activeSlideIdx: activeSlideIdx });
        }
    };
    return ContentSlider;
}(React.Component));
exports.ContentSlider = ContentSlider;
